import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const collectionsGridDefaultVariants = {
  "gap": "md",
  "padding": "md",
  "minColWidth": "md"
}
const collectionsGridCompoundVariants = []

const collectionsGridSlotNames = [
  [
    "root",
    "collections-grid__root"
  ],
  [
    "list",
    "collections-grid__list"
  ]
]
const collectionsGridSlotFns = /* @__PURE__ */ collectionsGridSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, collectionsGridDefaultVariants, getSlotCompoundVariant(collectionsGridCompoundVariants, slotName))])

const collectionsGridFn = memo((props = {}) => {
  return Object.fromEntries(collectionsGridSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const collectionsGridVariantKeys = [
  "gap",
  "padding",
  "minColWidth"
]
const getVariantProps = (variants) => ({ ...collectionsGridDefaultVariants, ...compact(variants) })

export const collectionsGrid = /* @__PURE__ */ Object.assign(collectionsGridFn, {
  __recipe__: false,
  __name__: 'collectionsGrid',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: collectionsGridVariantKeys,
  variantMap: {
  "gap": [
    "none",
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "padding": [
    "none",
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "minColWidth": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, collectionsGridVariantKeys)
  },
  getVariantProps
})